import api from '@/api/adsTier'

const state = {

}

const actions = {
  getAdsTierInfo (context, params) {
    return api.getAdsTierInfo(params)
  },
  saveAdsTierOrder (context, params) {
    return api.saveAdsTierOrder(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
